import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

/**
 * Selected-value badge inside dropdowns: primary tint surface with primary base
 * text and delete icon. Apply directly to the Chip so it overrides MUI's chip
 * defaults; disabled/active parent selectors stay more specific.
 */
export const primaryBadgeSx: SystemStyleObject<Theme> = {
  backgroundColor: "primary.light",
  color: "primary.main",
  "& .MuiChip-deleteIcon": { color: "primary.main" },
  "& .MuiChip-deleteIcon:hover": { color: "primary.main", opacity: 0.8 },
};
